module.exports = __webpack_public_path__ + "6957511df3e32958fa504efb71424c9c.svg";